import {Link} from "react-router-dom";
import ukMoment from "../../../../utils/ukTime";
import {useContext} from "react";
import AppContext from "../../../../context";

const BookingPreview = ({booking: { _id, status, reference, Event, tickets, totalPrice, BundlePurchase }}) => {
    const context = useContext(AppContext);
    const isHybrid = context.domain?.businessType === 'hybrid' || context.domain?.businessType === 'hybrid-new';
    const totalLabel = isHybrid ? `${totalPrice} token${totalPrice === 1 ? '' : 's'}` : `£${totalPrice}`;
    return (
        <Link to={`/account/bookings/${_id}`} className={"bg-backgroundGrey p-4 rounded-md flex justify-between"}>

                <div>
                    <div className={"flex items-center center gap-2 flex-wrap"}>
                        {status === "Cancelled" ? <p className={"text-xs bg-red-100 py-0.5 px-1 rounded-md border-red-300 border text-red-900"}>Cancelled</p> : null}
                        <p>{Event.Experience.name}</p>

                    </div>
                    <p className={"text-sm text-textGrey"}>{ukMoment(Event.date).format("MMM Do YYYY, H:mm A")} for {tickets} {tickets > 1 ? "people" : "person"}</p>
                </div>

                <div className={"text-right"}>
                    <p>{reference}</p>
                    <p className={"text-sm text-textGrey"}>{BundlePurchase ? 'Part of a Bundle' : totalLabel}</p>
                </div>

        </Link>
    )
}

export default BookingPreview
